import { z } from 'zod'
import type { TFunction } from 'i18next'

export const updateTenantSchema = z.object({
  id: z.string().uuid(),
  name: z
    .string()
    .min(1, 'validation.required')
    .max(255, 'validation.maxLength'),
  slug: z
    .string()
    .min(1, 'validation.required')
    .max(100, 'validation.maxLength')
    .regex(/^[a-z0-9-]+$/, 'validation.slugFormat'),
  domain: z
    .string()
    .url('validation.invalidUrl')
    .optional()
    .or(z.literal('')),
  logoUrl: z
    .string()
    .url('validation.invalidUrl')
    .optional()
    .or(z.literal('')),
  status: z.enum(['active', 'suspended', 'pending', 'cancelled']),
})

export type UpdateTenantFormData = z.infer<typeof updateTenantSchema>

// Factory function to create schema with translated messages
export function getUpdateTenantSchema(t: TFunction) {
  return z.object({
    id: z.string().uuid(),
    name: z
      .string()
      .min(1, t('validation.required', { field: t('admin.tenants.create.companyName') }))
      .max(255, t('validation.maxLength', { field: t('admin.tenants.create.companyName'), max: 255 })),
    slug: z
      .string()
      .min(1, t('validation.required', { field: t('admin.tenants.create.slug') }))
      .max(100, t('validation.maxLength', { field: t('admin.tenants.create.slug'), max: 100 }))
      .regex(/^[a-z0-9-]+$/, t('validation.slugFormat')),
    domain: z
      .string()
      .url(t('validation.invalidUrl'))
      .optional()
      .or(z.literal('')),
    logoUrl: z
      .string()
      .url(t('validation.invalidUrl'))
      .optional()
      .or(z.literal('')),
    status: z.enum(['active', 'suspended', 'pending', 'cancelled']),
  })
}
